import SimilarOffers from '@/components/SimilarOffers.js'
import { isOfferPage } from '@/modules/globals'

export function init () {
  const root = document.querySelector('.offer-list__slider')

  if (isOfferPage() && root) {
    new SimilarOffers(root).init()
  }
}


// WEBPACK FOOTER //
// ./src/modules/similarOffers.js